module.exports = __webpack_public_path__ + "img/sticker-warn.638165d9.svg";